import { useState } from "react";

export default function Rating({ value: initialValue, onChange }) {
  const [value, setValue] = useState(initialValue || 0);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleClick = (i) => {
    const newValue = i + 1;
    setValue(newValue);
    setShowConfirmation(true);

    // Hide confirmation after 2 seconds
    setTimeout(() => setShowConfirmation(false), 2000);

    // Update JSON object
    if (onChange) {
      onChange({ selectedStars: newValue });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
      <div style={{ display: 'flex', gap: '2px', color: '#FFD700', cursor: 'pointer' }}>
        {Array(5).fill().map((_, i) => (
          <span
            key={i}
            onClick={() => handleClick(i)}
            style={{ fontSize: '30px' }}
          >
            {i < value ? '★' : '☆'}
          </span>
        ))}
      </div>
      {showConfirmation && (
        <div style={{
          color: '#c2b280',
          fontSize: '14px',
          fontFamily: '"Ubuntu", sans-serif',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <span>✓</span>
          <span>Rating submitted!</span>
        </div>
      )}
    </div>
  );
}
